import React, { useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';

export default function ErrorMessages({ motor }) {
  const [showErrorDetails, setShowErrorDetails] = useState(false);

  const toggleErrorDetails = () => {
    setShowErrorDetails(!showErrorDetails);
  };

  // Fonction helper pour normaliser les valeurs
  const normalizeDefaut = (val) => {
    if (typeof val === 'string') {
      const lower = val.toLowerCase();
      if (lower === 'rouge') return 'rouge';
      if (lower === 'jaune') return 'jaune';
      if (lower === 'vert') return 'vert';
    }
    return 'null';
  };

  // Récupérer tous les détails vibratoires (dérive)
  const getAllDeriveVibratoireDetails = () => {
    const axes = [];
    
    // Récupérer les noms personnalisés des axes s'ils existent
    const axeX = motor.axeX || 'X';
    const axeY = motor.axeY || 'Y';
    const axeZ = motor.axeZ || 'Z';

    // Vérifier chaque axe et récupérer le typeDefaut et la vitesse
    if (motor.vitesse_avant_defaultX1) {
      const typeDefaut = normalizeDefaut(motor.typeDefautX1);
      if (typeDefaut === 'rouge' || typeDefaut === 'jaune') {
        axes.push({
          axe: `Axe ${axeX}`,
          vitesse: motor.vitesse_avant_defaultX1.toFixed(2) + ' mm/s',
          typeDefaut: typeDefaut,
          type: 'derive',
        });
      }
    }
    
    if (motor.vitesse_avant_defaultY1) {
      const typeDefaut = normalizeDefaut(motor.typeDefautY1);
      if (typeDefaut === 'rouge' || typeDefaut === 'jaune') {
        axes.push({
          axe: `Axe ${axeY}`,
          vitesse: motor.vitesse_avant_defaultY1.toFixed(2) + ' mm/s',
          typeDefaut: typeDefaut,
          type: 'derive',
        });
      }
    }
    
    if (motor.vitesse_avant_defaultZ1) {
      const typeDefaut = normalizeDefaut(motor.typeDefautZ1);
      if (typeDefaut === 'rouge' || typeDefaut === 'jaune') {
        axes.push({
          axe: `Axe ${axeZ}`,
          vitesse: motor.vitesse_avant_defaultZ1.toFixed(2) + ' mm/s',
          typeDefaut: typeDefaut,
          type: 'derive',
        });
      }
    }
    
    return axes;
  };

  // Récupérer tous les détails d'état vibratoire (typeDefautVitesse)
  const getAllEtatVibratoireDetails = () => {
    const axes = [];
    
    // Récupérer les noms personnalisés des axes s'ils existent
    const axeX = motor.axeX || 'X';
    const axeY = motor.axeY || 'Y';
    const axeZ = motor.axeZ || 'Z';

    // Position A (capteur 1)
    if (motor.typeDefautVitesseX1) {
      const typeDefaut = normalizeDefaut(motor.typeDefautVitesseX1);
      if (typeDefaut === 'rouge' || typeDefaut === 'jaune') {
        axes.push({
          axe: `Axe ${axeX}`,
          typeDefaut: typeDefaut,
          type: 'etat',
        });
      }
    }
    
    if (motor.typeDefautVitesseY1) {
      const typeDefaut = normalizeDefaut(motor.typeDefautVitesseY1);
      if (typeDefaut === 'rouge' || typeDefaut === 'jaune') {
        axes.push({
          axe: `Axe ${axeY}`,
          typeDefaut: typeDefaut,
          type: 'etat',
        });
      }
    }
    
    if (motor.typeDefautVitesseZ1) {
      const typeDefaut = normalizeDefaut(motor.typeDefautVitesseZ1);
      if (typeDefaut === 'rouge' || typeDefaut === 'jaune') {
        axes.push({
          axe: `Axe ${axeZ}`,
          typeDefaut: typeDefaut,
          type: 'etat',
        });
      }
    }
    
    return axes;
  };

  // Grouper et dédupliquer les messages d'erreur vibratoire
  const getDisplayMessages = () => {
    const messages = [];
    
    // Récupérer les détails des deux types d'erreurs
    const deriveAxes = getAllDeriveVibratoireDetails();
    const etatAxes = getAllEtatVibratoireDetails();
    
    // Créer des messages structurés pour les erreurs vibratoires
    if (deriveAxes.length > 0) {
      const hasCritical = deriveAxes.some(axis => axis.typeDefaut === 'rouge');
      const messageText = hasCritical 
        ? "⚠️ Dérive vibratoire importante détectée - Faire réparer la machine"
        : "⚠️ Dérive vibratoire à surveiller";
      
      messages.push({
        text: messageText,
        axes: deriveAxes,
        type: 'derive'
      });
    }
    
    if (etatAxes.length > 0) {
      const hasCritical = etatAxes.some(axis => axis.typeDefaut === 'rouge');
      const messageText = hasCritical 
        ? "⚠️ État vibratoire important détecté - Faire réparer la machine"
        : "⚠️ État vibratoire à surveiller";
      
      messages.push({
        text: messageText,
        axes: etatAxes,
        type: 'etat'
      });
    }
    
    // Ajouter les autres messages d'erreur (non vibratoires)
    const otherMessages = (motor.etatVibratoire || []).filter(msg => 
      !msg.includes('Dérive vibratoire') && 
      !msg.includes('dérive vibratoire') &&
      !msg.includes('État vibratoire') &&
      !msg.includes('état vibratoire')
    );
    
    otherMessages.forEach(msg => {
      messages.push({
        text: msg,
        axes: [],
        type: 'other'
      });
    });
    
    return messages;
  };

  const displayMessages = getDisplayMessages();
  const totalErrors = displayMessages.length;

  return (
    <div className="mt-8">
      {totalErrors > 0 && (
        <div
          className="flex items-center justify-between bg-red-500 text-white py-4 px-6 cursor-pointer rounded-2xl"
          style={{
            borderBottomLeftRadius: showErrorDetails ? '0' : '0.4em',
            borderBottomRightRadius: showErrorDetails ? '0' : '0.4em',
          }}
          onClick={toggleErrorDetails}
        >
          <span className="mr-auto ml-auto text-xs sm:text-lg md:text-xl lg:text-2xl xl:text-3xl text-center">
            ⚠️ Nombre de messages d'erreurs : {totalErrors} ⚠️
          </span>

          <FaChevronDown
            className={`ml-8 transition-transform duration-300 ${
              showErrorDetails ? 'rotate-180' : ''
            }`}
          />
        </div>
      )}

      {showErrorDetails && (
        <ul className="bg-[#ebb9b0] border-4 border-red-500 rounded-bl-lg rounded-br-lg border-t-0 text-red-700 list-none m-0 p-4">
          {displayMessages.map((message, index) => {
            const hasAxesDetails = message.axes && message.axes.length > 0;

            return (
              <li
                key={index}
                className="border-b-2 border-white text-base lg:text-3xl 3xl:text-4xl mb-8 mt-4"
              >
                <div className="font-bold mb-2">{message.text}</div>

                {hasAxesDetails && (
                  <div className="mt-4 space-y-3 text-lg lg:text-2xl">
                    {message.type === 'derive' && (
                      <div className="text-sm lg:text-xl italic mb-2">
                        Détails de la dérive vibratoire :
                      </div>
                    )}
                    {message.type === 'etat' && (
                      <div className="text-sm lg:text-xl italic mb-2">
                        Détails de l'état vibratoire :
                      </div>
                    )}
                    
                    {message.axes.map((axis, i) => (
                      <div key={i} className="flex items-center gap-2 ml-4">
                        <span 
                          className="inline-block w-3 h-3 rounded-full mr-2"
                          style={{
                            backgroundColor: axis.typeDefaut === 'rouge' ? '#dc3545' : '#ffc107'
                          }}
                        />
                        <span>
                          <b>{axis.axe}</b>
                          {message.type === 'derive' && (
                            <> — Vitesse : <b>{axis.vitesse}</b></>
                          )}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}